var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vwc-badge",
    {
      attrs: {
        id: _vm.id,
        connotation: _vm.connotation,
        shape: _vm.shape,
        translucent: _vm.shape,
        outlined: _vm.outlined,
        layout: _vm.layout,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }